export const PROFILE_MODULE_NAMESPACE = 'profile';
export const PROFILE_LOADING = 'PROFILE_LOADING';
export const PROFILE_CHANGE_EMAIL = 'PROFILE_CHANGE_EMAIL'
export const PROFILE_IS_MANAGEMENT_PAGE= 'PROFILE_IS_MANAGEMENT_PAGE'
export const PROFILE_GET_ENTITY_ROLES = 'PROFILE_GET_ENTITY_ROLES'
export const PROFILE_GET_ALL_ENTITY_ROLES = 'PROFILE_GET_ALL_ENTITY_ROLES'
export const PROFILE_SET_INTERNAL_ROLES = 'PROFILE_SET_INTERNAL_ROLES'
export const PROFILE_SET_EXTERNAL_ROLES= 'PROFILE_SET_EXTERNAL_ROLES'
export const PROFILE_GET_CIVILITY_LEGAL_FORM = 'PROFILE_GET_CIVILITY_LEGAL_FORM'
export const PROFILE_SET_CIVILITY_LEGAL_FORM = 'PROFILE_SET_CIVILITY_LEGAL_FORM'
export const PROFILE_GET_MEMBERS = 'PROFILE_GET_MEMBERS'
export const PROFILE_GET_CONTACT = 'PROFILE_GET_CONTACT'
export const PROFILE_SET_MEMBERS = 'PROFILE_SET_MEMBERS'
export const PROFILE_EXTEND_MEMBERS = 'PROFILE_EXTEND_MEMBERS'
export const PROFILE_SPLICE_MEMBERS = 'PROFILE_SPLICE_MEMBERS'
export const PROFILE_UPDATE_MEMBERS= 'PROFILE_UPDATE_MEMBERS'
export const PROFILE_SET_TOTAL_PAGES = 'PROFILE_SET_TOTAL_PAGES'
export const PROFILE_SET_PAGINATION_PAGE = 'PROFILE_SET_PAGINATION_PAGE'
export const PROFILE_SET_ENTITY_ROLES = 'PROFILE_SET_ENTITY_ROLES'
export const PROFILE_SET_CURRENT_FILTER = 'PROFILE_SET_CURRENT_FILTER'
export const PROFILE_RESET_MEMBERS= 'PROFILE_RESET_MEMBERS'
export const PROFILE_INIT_MEMBERS = 'PROFILE_INIT_MEMBERS'
export const PROFILE_FILTER_CHANGE = 'PROFILE_FILTER_CHANGE'
export const PROFILE_RESET_MEMBER = 'PROFILE_RESET_MEMBER'
export const PROFILE_INIT_MEMBER = 'PROFILE_INIT_MEMBER'
export const PROFILE_INIT_CURRENT_MEMBER = 'PROFILE_INIT_CURRENT_MEMBER'
export const PROFILE_RECORD_MEMBER = 'PROFILE_RECORD_MEMBER'
export const PROFILE_UPDATE_MEMBER = 'PROFILE_UPDATE_MEMBER'
export const PROFILE_UPDATE_SIGNATURE = 'PROFILE_UPDATE_SIGNATURE'
export const PROFILE_DELETE_MEMBER = 'PROFILE_DELETE_MEMBER'
export const PROFILE_DELETE_MEMBERS = 'PROFILE_DELETE_MEMBERS'
export const PROFILE_EDIT_MEMBER = 'PROFILE_EDIT_MEMBER'
export const PROFILE_SET_MEMBER_BY_FIELD = 'PROFILE_SET_MEMBER_BY_FIELD'
export const PROFILE_SET_MEMBER_PARAMETER = 'PROFILE_SET_MEMBER_PARAMETER'
export const PROFILE_ACTION = 'PROFILE_ACTION'
export const PROFILE_SET_MEMBER_SELECTION = 'PROFILE_SET_MEMBER_SELECTION'
export const PROFILE_INIT_MEMBER_SELECTION = 'PROFILE_INIT_MEMBER_SELECTION'
export const PROFILE_SET_LOADER_STATE = 'PROFILE_SET_LOADER_STATE'
export const PROFILE_SET_TICKET_CLOSING_REASON = 'PROFILE_SET_TICKET_CLOSING_REASON'
export const PROFILE_SET_TICKET_REASON = 'PROFILE_SET_TICKET_REASON'
export const PROFILE_SET_TICKET_SUBSTATUS = 'PROFILE_SET_TICKET_SUBSTATUS'
export const PROFILE_LOADERS= Object.freeze({
    MEMBERS_FILTERS: 'PROFILE_MEMBERS_FILTERS',
    MEMBERS_TABLE: 'PROFILE_MEMBERS_TABLE'
})



// WEBPACK FOOTER //
// ./src/store/profile/profile-types.store.ts